import { useTranslation } from 'react-i18next';

interface StaffAttendanceStatsBarProps {
  totalStaff: number;
  presentCount: number;
  absentCount: number;
  onLeaveCount: number;
  halfDayCount: number;
}

export default function StaffAttendanceStatsBar({
  totalStaff,
  presentCount,
  absentCount,
  onLeaveCount,
  halfDayCount,
}: StaffAttendanceStatsBarProps) {
  const { t } = useTranslation();
  const presentRate = totalStaff > 0 ? Math.round((presentCount / totalStaff) * 100) : 0;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-5">
      {/* Total Staff */}
      <div className="bg-background-50 rounded-xl border border-background-200 px-4 py-3.5 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
          <i className="ri-team-line text-accent-600 text-base" />
        </div>
        <div>
          <p className="text-xs font-label text-foreground-400">{t('attendance.totalStaff')}</p>
          <p className="text-lg font-heading font-700 text-foreground-800">{totalStaff}</p>
        </div>
      </div>

      {/* Present */}
      <div className="bg-background-50 rounded-xl border border-background-200 px-4 py-3.5 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-semantic-success-bg">
          <i className="ri-check-line text-semantic-success text-base" />
        </div>
        <div>
          <p className="text-xs font-label text-foreground-400">{t('attendance.present')}</p>
          <p className="text-lg font-heading font-700 text-foreground-800">
            {presentCount}
            <span className="text-xs font-label font-normal text-foreground-400 ml-1">({presentRate}%)</span>
          </p>
        </div>
      </div>

      {/* Absent */}
      <div className="bg-background-50 rounded-xl border border-background-200 px-4 py-3.5 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-semantic-error-bg">
          <i className="ri-close-line text-semantic-error text-base" />
        </div>
        <div>
          <p className="text-xs font-label text-foreground-400">{t('attendance.absent')}</p>
          <p className="text-lg font-heading font-700 text-foreground-800">{absentCount}</p>
        </div>
      </div>

      {/* Half-day */}
      <div className="bg-background-50 rounded-xl border border-background-200 px-4 py-3.5 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-semantic-warning-bg">
          <i className="ri-contrast-drop-2-line text-semantic-warning text-base" />
        </div>
        <div>
          <p className="text-xs font-label text-foreground-400">{t('attendance.halfDay')}</p>
          <p className="text-lg font-heading font-700 text-foreground-800">{halfDayCount}</p>
        </div>
      </div>

      {/* On Leave */}
      <div className="bg-background-50 rounded-xl border border-background-200 px-4 py-3.5 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100">
          <i className="ri-calendar-event-line text-secondary-600 text-base" />
        </div>
        <div>
          <p className="text-xs font-label text-foreground-400">{t('attendance.onLeave')}</p>
          <p className="text-lg font-heading font-700 text-foreground-800">{onLeaveCount}</p>
        </div>
      </div>

      {/* Rate */}
      <div className="bg-background-50 rounded-xl border border-background-200 px-4 py-3.5 flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
          <i className="ri-bar-chart-2-line text-accent-600 text-base" />
        </div>
        <div>
          <p className="text-xs font-label text-foreground-400">{t('attendance.attendanceRate')}</p>
          <p className="text-lg font-heading font-700 text-foreground-800">{presentRate}%</p>
        </div>
      </div>
    </div>
  );
}